import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { rutFormat } from 'rut-helpers'
import formatMoney from 'accounting-js/lib/formatMoney'
import moment from 'moment'

moment.locale('es')

const currencies = [
  { id: 'USD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'US', name: 'Dólar estadounidense', conversion: null },
  { id: 'ARS', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'AR', name: 'Peso argentino', conversion: null },
  { id: 'AUD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'AU', name: 'Dólar australiano', conversion: null },
  { id: 'CAD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CA', name: 'Dólar canadiense', conversion: null },
  { id: 'CHF', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CH', name: 'Franco suizo', conversion: null },
  { id: 'CLF', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CL', name: 'Unidad de fomento chilena', conversion: 'CLP' },
  { id: 'CLP', format: { precision: 0, thousand: '.', decimal: ',' }, country: 'CL', name: 'Peso chileno', conversion: null },
  { id: 'CZK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'CZ', name: 'Corona checa', conversion: null },
  { id: 'DKK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'DK', name: 'Corona danesa', conversion: null },
  { id: 'EUR', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'EU', name: 'Euro', conversion: null },
  { id: 'GBP', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'GB', name: 'Libra esterlina', conversion: null },
  { id: 'HKD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'HK', name: 'Dólar hongkonés', conversion: null },
  { id: 'HUF', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'HU', name: 'Florín húngaro', conversion: null },
  { id: 'IDR', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'ID', name: 'Rupia indonesia', conversion: null },
  { id: 'ILS', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'IL', name: 'Nuevo shekel israelí', conversion: null },
  { id: 'JPY', format: { precision: 0, thousand: '.', decimal: ',' }, country: 'JP', name: 'Yen japones', conversion: null },
  { id: 'MYR', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'MY', name: 'Ringgit malayo', conversion: null },
  { id: 'MXN', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'MX', name: 'Peso mexicano', conversion: null },
  { id: 'NOK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'NO', name: 'Corona noruega', conversion: null },
  { id: 'NZD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'NZ', name: 'Dólar neozelandés', conversion: null },
  { id: 'PHP', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'PH', name: 'Peso filipino', conversion: null },
  { id: 'PLN', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'PL', name: 'Zloty polaco', conversion: null },
  { id: 'RUB', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'RU', name: 'Rublo ruso', conversion: null },
  { id: 'SEK', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'SE', name: 'Corona sueca', conversion: null },
  { id: 'SGD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'SG', name: 'Dólar singapurense', conversion: null },
  { id: 'TWD', format: { precision: 2, thousand: ',', decimal: '.' }, country: 'TW', name: 'Nuevo dólar taiwanés', conversion: null }
]

export default {
  directives: {
    mask,
    dni: {
      update: function (el, binding, vnode) {
        let country = binding.value || 'CL'
        if (vnode.context.listenerAttached) {
          el.removeEventListener('input', vnode.context.rutFunction)
          vnode.context.listenerAttached = false
        }
        vnode.context.rutFunction = (e) => {
          vnode.componentInstance.$emit('input', country === 'CL' ? rutFormat(e.target.value) : e.target.value)
        }
        el.addEventListener('input', vnode.context.rutFunction)
        vnode.context.listenerAttached = true
      }
    }
  },
  data: () => ({
    currencies: currencies,
    today: moment().format('YYYY-MM-DD'),
    dropdowns: [],
    dropdownShow: false
  }),
  computed: mapState({
    account: state => state.auth.account.id
  }),
  filters: {
    capitalize (val) {
      return `${val.toString().charAt(0).toUpperCase()}${val.toString().slice(1)}`
    },
    currency (value, id) {
      const currency = currencies.find(c => c.id === id)
      if (!currency) {
        return value
      }
      const options = Object.assign({}, currency.format, { symbol: '' })
      return formatMoney(value, options)
    },
    date (val) {
      return moment(val).format('DD MMM YYYY')
    },
    dateTime (val) {
      return moment(val).format('DD MMM YYYY, h:mm')
    }
  }
}
